require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-sukkah-detroit.json") })
        }
      }, "path---project-sukkah-detroit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-sukkah-detroit!./.cache/json/project-sukkah-detroit.json
// module id = 355
// module chunks = 231608221292675